

































import Loader from '@/components/Global/Loader.vue'
import Trip from '@/components/Map/TripsTab/Trip.vue'
import Header from '@/components/Map/TripsTab/Header.vue'
import { apiGetDebugTrips } from '@/api'

export default {
  name: 'TripsTab',
  components: { Loader, Trip, Header },
  props: {
    entity: {
      required: true
    },
    tab: String
  },
  data: () => ({
    loading: false,
    weekdays: [],
    requested: [],
    loaded: [],
    errors: [],
    timeLastUpdated: Date.now()
  }),
  methods: {
    getTrips () {
      this.weekdays = []
      this.loading = true
      apiGetDebugTrips(this.entity.id)
        .then(res => {
          this.loading = false
          res.data.data.forEach((trip: any) => this.addTrip(trip))
        })
    },
    addTrip (trip: any) {
      if (this.weekdays.some((day: any) => day.trips.some((dt: any) => dt.id === trip.id))) return

      let secondsBetweenStartStop = this.$moment(trip.trip_ended_at).diff(trip.trip_started_at, 'seconds')
      if (!(trip.duration > secondsBetweenStartStop)) {
        secondsBetweenStartStop = trip.duration
      }

      const number = this.$moment(trip.trip_started_at).startOf('day').format('X')
      const index = this.weekdays.findIndex((d: any) => d.id === number)

      if (index === -1) {
        this.weekdays.push({
          id: number,
          day: this.$moment(trip.trip_started_at).format('dddd, LL'),
          totals: {
            distance: trip.distance,
            duration: secondsBetweenStartStop
          },
          trips: [trip]
        })

        return true
      }

      this.weekdays[index] = {
        ...this.weekdays[index],
        totals: {
          distance: this.weekdays[index].totals.distance + trip.distance,
          duration: this.weekdays[index].totals.duration + secondsBetweenStartStop
        },
        trips: [
          ...this.weekdays[index].trips,
          trip
        ]
      }
    }
  },
  mounted () {
    this.getTrips()
  },
  watch: {
    tab (val: string) {
      if (val !== 'trips') return
      this.getTrips()
    }
  }
}
